type GetApolloClientArgs<TClient> = {
	useAggClient?: boolean;
	client?: TClient;
};

export function getApolloClient<TClient = Window['GLOBAL_APOLLO_CLIENT']>({
	useAggClient,
	client,
}: GetApolloClientArgs<TClient> = {}): TClient | undefined {
	if (useAggClient) {
		// AGG-backed interops need to mirror into the same Apollo cache their
		// primary operation used, otherwise bridge writes can land in the wrong client.
		return (window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']) as
			| TClient
			| undefined;
	}

	return client ?? (window['GLOBAL_APOLLO_CLIENT'] as TClient | undefined);
}
